// Prominent, consistent "chapter" marker used at the start of each major
// section so the eye immediately recognises a new section has begun.
// Uses only the existing brand teal as an accent — no new colours, no boxes.
export const SectionMarker = ({ n, label, className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`} data-testid={`section-marker-${n}`}>
    <span
      aria-hidden="true"
      className="font-display text-4xl sm:text-5xl font-extrabold leading-none text-transparent select-none"
      style={{ WebkitTextStroke: "1.2px rgba(0,240,255,0.42)" }}
    >
      {n}
    </span>
    <span className="h-9 w-px bg-gradient-to-b from-teal/70 to-transparent" aria-hidden="true" />
    <span className="font-mono text-xs uppercase tracking-[0.28em] text-teal">{label}</span>
  </div>
);
